import clsx from "clsx";

import { Tooltip } from "@/components/ui/tooltip/Tooltip";

import {
  isDocumentContentUnreadable,
  type DocumentClassificationUiState,
} from "@/components/case-checking/documentClassificationUi";

type DocumentContentUnreadableHintProps = {
  doc: DocumentClassificationUiState;
  className?: string;
};

export function DocumentContentUnreadableHint({ doc, className }: DocumentContentUnreadableHintProps) {
  if (!isDocumentContentUnreadable(doc)) {
    return null;
  }

  const reason = doc.metadata?.unreadable_reason?.trim();
  const chip = (
    <span
      className={clsx(
        "inline-flex px-2 py-0.5 text-[10px] font-medium rounded-full ring-1 ring-slate-200 dark:ring-white/10 text-slate-500 dark:text-slate-400",
        className,
      )}
      data-testid="document-content-unreadable-hint"
      title={reason || undefined}
    >
      Content not readable — classified from filename
    </span>
  );

  if (!reason) {
    return chip;
  }

  return (
    <Tooltip
      content={<p className="text-sm leading-relaxed max-w-sm whitespace-pre-wrap">{reason}</p>}
      placement="top"
      maxWidth="24rem"
    >
      {chip}
    </Tooltip>
  );
}
